import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { HttpHeaders, HttpParams, HttpClient } from '@angular/common/http';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/public_api';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { SWAlertService } from '../../services/swalert.service';
import Swal from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';

@Component({
  selector: 'app-admin-receivingdoc',
  templateUrl: './admin-receivingdoc.component.html',
  styleUrls: ['./admin-receivingdoc.component.css']
})
export class AdminReceivingdocComponent implements OnInit {
  ReceivingDocForm: FormGroup;//สร้างกลุ่ม Object Data
  get f() { return this.ReceivingDocForm.controls; }//ประกาศเพื่อใช้เรียกไปยัง From หน้าบ้าน

  constructor(private formBuilder: FormBuilder,
    private http: HttpClient,
    private System: TSFuntionService,
    private swal: SWAlertService,
    private router: Router,
    private activatedRoute: ActivatedRoute) { }

  DataReqID: any = []; //ตัวแปร array เก็บค่า sRequestID
  ArrReqID: any[] = []; //ตัวแปร array เก็บค่า sRequestID
  DataReqType: any = []; //ตัวแปร array เก็บค่า Request Type
  sDetailData = "";
  sRequestID = "";
  IsHeaderSort = "";
  SortDirection = "";
  SortICO = "fas fa-sort";
  IcoSort = "fas fa-sort";
  IcoSortDesc = "fas fa-sort-down";
  IcoSortAsc = "fas fa-sort-up";
  _ArrData = [];
  _ArrDataFilter = [];
  _ArrDataBind = [];
  _Delete = null;
  _NoResult = false;
  ResultPermission: boolean = false;
  ResultPermissionMunu: boolean = false;
  IsViewMode: boolean = false;
  ua: any;

  public settings = {};

  async ngOnInit() {
    this.System.BlockUI();
    this.ua = this.System.GetUserStorage();
    this.ReceivingDocForm = this.formBuilder.group({
      sRequestID: ["", Validators.required],
      sBarcode: [""],
      sSearch: [""],
      nReqType: [""],
      nPaging: [""],
      nPageSize: [""]
    });
    this.SetDataOnPageLoad();
    this.settings = {
      singleSelection: false,
      idField: 'sValue',
      textField: 'sText',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };

    //รับค่า sRequestID จากหน้า Home ผ่าน Parameter ชื่อ str
    this.activatedRoute.queryParams.subscribe(params => {
      this.sRequestID = (params['str']);
    });
    this.sRequestID = await this.System.Decrypt(this.sRequestID);
    if (this.sRequestID) {
      await this.SetData(this.sRequestID);
    }

    //Check Permission Menu
    let ObjData = {
      sRequestID: "",
      nMenuID: 17
    }
    this.ResultPermission = await this.System.CheckPermission(ObjData);
    if (this.ResultPermission) {
      //Check Permission Admin
      this.ResultPermissionMunu = await this.System.CheckPermissionMeun(17);
      if (!this.ResultPermissionMunu) {
        this.ReceivingDocForm.controls.sRequestID.disable();
        this.ReceivingDocForm.controls.sBarcode.disable();

        this.IsViewMode = true;
      }
    }

    this.System.UnBlockUI();
  }

  //#region Set Data On Page Load
  SetDataOnPageLoad() {
    //AutocompleteReqID
    const httpOptionsTUserpermission = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),params: new HttpParams()
        .set('nStatusID', '6')
        .set('sCompCode', this.ua.sCompCode)
    };
    this.http.get<any>(this.System.SiteName + "api/AdminReceivingDoc/GetReqID", httpOptionsTUserpermission).subscribe(res => {
      if (res) {
        this.DataReqID = res;
        this.ArrReqID = this.DataReqID.map(m => ({
          sRequestID: m.sRequestID,
          sRequestCode: m.sRequestCode
        }));
      }
    });
    //DropDownSearchRequestType
    this.http.get<any>(this.System.SiteName + "api/AdminReceivingDoc/GetReqType").subscribe(res => {
      this.DataReqType = res;
    });
  }
  //#endregion

  //#region Filter Grid
  FilterGrid = {
    sSearch: "",
    nReqType: []
  }
  //#endregion

  //#region Filter Grid
  OptionGrid = {
    nCurrentPage: 1,
    maxSize: 7,
    nPageSize: 10,
    nTotalItem: 0,
    ArrPageSize: [
      { sValue: 10 },
      { sValue: 20 },
      { sValue: 50 },
      { sValue: 100 }
    ]
  }
  //#endregion

  //#region Sort Data : Event Click Header
  SortHeaderClick(ColumnName: string, SortField: string) {
    if (ColumnName) {
      if (ColumnName === this.IsHeaderSort) {
        this.SortDirection = this.SortDirection === 'asc' ? 'desc' : 'asc';
        this.SortICO = (this.SortDirection === 'asc') ? this.IcoSortAsc : this.IcoSortDesc;
      }
      else {
        this.SortICO = this.IcoSortAsc;
        this.SortDirection = 'asc';
      }
      this.IsHeaderSort = ColumnName;
      this._ArrData = _.orderBy(this._ArrData, [SortField], [this.SortDirection]);
      this.BindDataTable();
    }
  }
  //#endregion

  //#region Page Size Change
  PageSizeChange() {
    setTimeout(() => {
      this.OptionGrid.nCurrentPage = 1;
    });
    this.BindDataTable();
  }
  //#endregion

  //#region Page Changed
  PageChanged(event: any) {
    this.OptionGrid.nCurrentPage = event.page;
    this.BindDataTable();
  }
  //#endregion

  //#region On Options Selected ReqID
  onOptionsSelected_ReqID(event: TypeaheadMatch): void {
    let txtSearch = event.item['sRequestID'];
    let lstData = this.ArrReqID.filter(f => f.sRequestID == txtSearch.trim())[0];
    if (lstData != "") {
      this.ReceivingDocForm.patchValue({
        sRequestID: lstData.sRequestCode + ""
      });
    } else {
      this.ReceivingDocForm.patchValue({
        sRequestID: ""
      });
    }
  }
  //#endregion

  //#region Autocomplete ReqID : NoResults , OnBlur
  typeaheadNoResults_ReqID(event: boolean): void { //เช็คว่า autocomplete มี value ?
    this._NoResult = event; //true,false
  }

  typeaheadOnBlur_ReqID(event: boolean): void { //เช็คว่า autocomplete มี value ?
    if (this._NoResult == true) { //ไม่มีให้ blur
      this.ReceivingDocForm.patchValue({
        sRequestID: ""
      });
    }
  }
  //#endregion

  //#region isFieldValid
  isFieldValid(field: string) {
    return !this.ReceivingDocForm.get(field).valid && this.ReceivingDocForm.get(field).touched;
  }
  //#endregion

  //#region displayFieldCss
  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }
  //#endregion

  //#region displayFieldCss
  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }
  //#endregion

  //#region Button Search Data
  SearchData() {
    if (this._ArrDataFilter.length > 1) {
      let _sReqType: string = this.FilterGrid.nReqType.length > 0 ? this.FilterGrid.nReqType.map(e => e.sValue).join(",") : "";
      this._ArrData = this._ArrDataFilter.filter(f =>
        (f.sRequestCode + "^" + f.sVendorName).indexOf((this.FilterGrid.sSearch).replace(/\s/g, "")) != -1 &&
          _sReqType == "" ? true : (_sReqType).indexOf(f.nReqType + "") != -1
      );
      this.BindDataTable();
    } else {
      this._ArrData = [];
    }
  }
  //#endregion

  //#region 1.Header Colomn
  Columns = [
    { ColumnName: "", SortField: "", Width: "5%" },
    { ColumnName: "", SortField: "", Width: "3%" },
    { ColumnName: "Req. No.", SortField: "sRequestCode", Width: "10%" },
    { ColumnName: "Type", SortField: "sReqType", Width: "10%" },
    { ColumnName: "Vendor / Customer Name", SortField: "sVendorName", Width: "23%" },
    { ColumnName: "", SortField: "", Width: "3%" },
    { ColumnName: "Due Date", SortField: "dDueDate", Width: "8%" },
    { ColumnName: "Net Total ", SortField: "nTotalAmount", Width: "10%" },
    //{ ColumnName: "Vat", SortField: "nTotalAmtVat", Width: "10%" },
    { ColumnName: "Cur.", SortField: "sCurrency", Width: "5%" },
    { ColumnName: "MD Approve", SortField: "dApprove", Width: "13%" }
  ]
  //#endregion

  //#region 2.Button Add , Barcode to Table
  async Add(item) {
    this.System.BlockUI();
    //Clear Validate
    switch (item) {
      case 2:
        this.ReceivingDocForm.get("sRequestID").markAsUntouched({ onlySelf: true });
        this.ReceivingDocForm.controls["sRequestID"].setErrors(null);
        this.ReceivingDocForm.controls["sRequestID"].updateValueAndValidity();
        break;
      default:
    }

    if (this.isFieldValid('sRequestID')) {
      //Check Validate All Dorm
      this.System.UnBlockUI();
    } else {
      //Check Textbox Add or Barcode
      let ID;
      if (item == 1) {
        ID = this.ReceivingDocForm.value.sRequestID;
      } else {
        ID = this.ReceivingDocForm.value.sBarcode;
      }

      //Check ReqID
      let _CheckDup: any = await this.CheckDuplicateData(ID);
      if (_CheckDup.IsPass) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          }),
          params: new HttpParams()
            .set('sRequestCode', ID)
        };
        this.http.get<any>(this.System.SiteName + "api/AdminReceivingDoc/ListData", httpOptions).subscribe(res => {
          if (res) {
            this._ArrDataFilter.push({
              sRequestID: res[0].sRequestID,
              IsReqUrgent: res[0].IsReqUrgent,
              IsSSCUrgent: res[0].IsSSCUrgent,
              sRequestCode: res[0].sRequestCode,
              nReqType: res[0].nReqType,
              sReqType: res[0].sReqType,
              sVendorName: res[0].sVendorName,
              IsVendorGroup: res[0].IsVendorGroup,
              dDueDate: res[0].dDueDate,
              sDueDate: res[0].sDueDate,
              nTotalAmount: res[0].nTotalAmount,
              nTotalAmtVat: res[0].nTotalAmtVat == null ? 0 : res[0].nTotalAmtVat,
              sCurrency: res[0].sCurrency,
              dApprove: res[0].dApprove,
              sApprove: res[0].sApprove,
              IsDelete: res[0].IsDelete
            });
            this.ReceivingDocForm.patchValue({
              sRequestID: "",
              sBarcode: ""
            });
            this.ReceivingDocForm.get("sRequestID").markAsUntouched({ onlySelf: true }); //สั่งให้ไม่คลิก
            this.ReceivingDocForm.controls["sRequestID"].setErrors(null);//ปรับ Control ให้เป็นปกติ
            this.ReceivingDocForm.controls["sRequestID"].updateValueAndValidity();//Update Validate

            this.ReceivingDocForm.get("sBarcode").markAsUntouched({ onlySelf: true }); //สั่งให้ไม่คลิก
            this.ReceivingDocForm.controls["sBarcode"].setErrors(null);//ปรับ Control ให้เป็นปกติ
            this.ReceivingDocForm.controls["sBarcode"].updateValueAndValidity();//Update Validate

            this._ArrData = [];
            this._ArrDataFilter.forEach(val => this._ArrData.push(Object.assign({}, val)));
            this.BindDataTable();
            this.System.UnBlockUI();
          } else {
            this.swal.SwAlert.Error(this.swal.BoxMsg.Title_Error, _CheckDup.Msg, function () { Swal.close(); });
            this.ReceivingDocForm.patchValue({
              sRequestID: "",
              sBarcode: ""
            });
            this.ReceivingDocForm.get("sRequestID").markAsUntouched({ onlySelf: true }); //สั่งให้ไม่คลิก
            this.ReceivingDocForm.controls["sRequestID"].setErrors(null);//ปรับ Control ให้เป็นปกติ
            this.ReceivingDocForm.controls["sRequestID"].updateValueAndValidity();//Update Validate

            this.ReceivingDocForm.get("sBarcode").markAsUntouched({ onlySelf: true }); //สั่งให้ไม่คลิก
            this.ReceivingDocForm.controls["sBarcode"].setErrors(null);//ปรับ Control ให้เป็นปกติ
            this.ReceivingDocForm.controls["sBarcode"].updateValueAndValidity();//Update Validate
            this.System.UnBlockUI();
          }
        });
      } else {
        this.swal.SwAlert.Error(this.swal.BoxMsg.Title_Error, _CheckDup.Msg, function () { Swal.close(); });
        this.ReceivingDocForm.patchValue({
          sRequestID: "",
          sBarcode: ""
        });
        this.ReceivingDocForm.get("sRequestID").markAsUntouched({ onlySelf: true }); //สั่งให้ไม่คลิก
        this.ReceivingDocForm.controls["sRequestID"].setErrors(null);//ปรับ Control ให้เป็นปกติ
        this.ReceivingDocForm.controls["sRequestID"].updateValueAndValidity();//Update Validate

        this.ReceivingDocForm.get("sBarcode").markAsUntouched({ onlySelf: true }); //สั่งให้ไม่คลิก
        this.ReceivingDocForm.controls["sBarcode"].setErrors(null);//ปรับ Control ให้เป็นปกติ
        this.ReceivingDocForm.controls["sBarcode"].updateValueAndValidity();//Update Validate
        this.System.UnBlockUI();
      }
    }
  }
  //#endregion

  //#region 4.Check Duplicate Data
  async CheckDuplicateData(ID) {
    this.System.BlockUI();
    let Result = { IsPass: true, Msg: "" };
    //Case 1 เช็คจาก Database
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('sRequestCode', ID)
    };
    let _CHKDup = await this.http.get<any>(this.System.SiteName + "api/AdminReceivingDoc/CheckDuplicateData", httpOptions).toPromise();
    if (_CHKDup) { //ถ้ามี Return ส่งสถานะมาจาก Base
      if (_CHKDup != "Wait Doc Receiving") {
        Result.IsPass = false;
        Result.Msg = this.swal.BoxMsg.Desc_Warning_Status + _CHKDup;
      }
      else {
        Result.IsPass = true;
      }
    } else { //ถ้าไม่มี Return
      Result.IsPass = false;
      Result.Msg = this.swal.BoxMsg.Desc_Error_Information;
    }
    //Case 2 เช็คจาก Array
    if (Result.IsPass) { //ถ้าเป็น True
      let DupReqID = this._ArrDataFilter.filter(f => //ฟิลเตอร์ ReqID
        f.sRequestCode == this.ReceivingDocForm.controls['sRequestID'].value &&
        f.IsDelete == false
      );
      let _DupReqID = this._ArrDataFilter.filter(f => //ฟิลเตอร์ ReqID
        f.sRequestCode == this.ReceivingDocForm.controls['sBarcode'].value &&
        f.IsDelete == false
      );
      if (DupReqID.length > 0 || _DupReqID.length > 0) { //ถ้ามี ReqID
        Result.IsPass = false;
        Result.Msg = this.swal.BoxMsg.Desc_Warning_Duplicate;
      }
    }
    this.System.UnBlockUI();
    return Result;
  }
  //#endregion

  //#region 5.Bind Data Table
  BindDataTable() {
    this.OptionGrid.nTotalItem = this._ArrData.length;

    let nStartIndex_Take = (this.OptionGrid.nCurrentPage - 1) * this.OptionGrid.nPageSize;
    let nEndIndex_Take = this.OptionGrid.nPageSize;
    this._ArrDataBind = [];
    this._ArrData.forEach(val => this._ArrDataBind.push(Object.assign({}, val)));
    this._ArrDataBind = this._ArrDataBind.splice(nStartIndex_Take, nEndIndex_Take);

    let nStartItemPage = nStartIndex_Take + 1;
    let nLastItemPage = nStartIndex_Take + this._ArrDataBind.length;
    this.sDetailData = "Showing " + nStartItemPage + " to " + nLastItemPage + " of " + this._ArrData.length + " Rows";
  }
  //#endregion

  //#region 5.On Click
  onClick(value: string) {
    let _this = this;
    let str = this.sRequestID;
    switch (value) {
      case "Submit":
        if (this._ArrData.length == 0) {
          this.validateAllFormFields(this.ReceivingDocForm);
          this.swal.SwAlert.Error(this.swal.BoxMsg.Title_Error, this.swal.BoxMsg.Desc_Warning_Information, function () { Swal.close(); });
        } else {
          this.swal.SwAlert.Confirm(this.swal.BoxMsg.Title_Confirm, "Do you want to receive document?", function () { _this.Save() }, undefined)
        }
        break;
      case "Back":
        this.router.navigate(["/admin-menu"]);
        break;
      default:
    }
  }
  //#endregion

  //#region Button Save Doc Receiving
  Save() {
    this.System.BlockUI();
    let _this = this;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
    };
    let _ObjData = {
      Treq: _this._ArrDataFilter
    }
    this.http.post(this.System.SiteName + "api/AdminReceivingDoc/UpdateStatus", _ObjData, httpOptions).subscribe(res => {
      if (res == "Success") {
        this.swal.SwAlert.Success(this.swal.BoxMsg.Title_Success, this.swal.BoxMsg.Desc_Success_Save, undefined);
        this._ArrData = [];
        this._ArrDataFilter = [];
        this._ArrDataFilter.forEach(val =>
          this._ArrData.push(Object.assign({}, val))
        )
        this.SetDataOnPageLoad();
        this.BindDataTable();
      } else {
        this.swal.SwAlert.Error(this.swal.BoxMsg.Title_Error, this.swal.BoxMsg.Desc_Error, undefined);
      }
    });
    this.System.UnBlockUI();
  }
  //#endregion

  //#region Button Delete
  Delete(_Item) {
    this.System.BlockUI();
    let _this = this;
    let _Delete = function () {
      _this._ArrDataFilter = _this._ArrDataFilter.filter(f => f.sRequestID != _Item.sRequestID)
      _this._ArrData = [];
      _this._ArrDataFilter.forEach(val =>

        _this._ArrData.push(Object.assign({}, val))
      )
      _this.BindDataTable();
    }
    this.swal.SwAlert.Confirm(this.swal.BoxMsg.Title_Confirm, this.swal.BoxMsg.Desc_Confirm_Delete, _Delete, function () { });
    this.System.UnBlockUI();
  }
  //#endregion

  //#region Button Edit
  async SetData(sRequestID) {
    this.System.BlockUI();
    this.sRequestID = sRequestID;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('sRequestID', this.sRequestID)
    };
    let res = await this.http.get<any>(this.System.SiteName + "api/AdminReceivingDoc/SetData", httpOptions).toPromise();
    if (res) {
      this._ArrDataFilter.push({
        sRequestID: res[0].sRequestID,
        IsReqUrgent: res[0].IsReqUrgent,
        IsSSCUrgent: res[0].IsSSCUrgent,
        sRequestCode: res[0].sRequestCode,
        nReqType: res[0].nReqType,
        sReqType: res[0].sReqType,
        sVendorName: res[0].sVendorName,
        IsVendorGroup: res[0].IsVendorGroup,
        dDueDate: res[0].dDueDate,
        sDueDate: res[0].sDueDate,
        nTotalAmount: res[0].nTotalAmount,
        nTotalAmtVat: res[0].nTotalAmtVat == null ? 0 : res[0].nTotalAmtVat,
        sCurrency: res[0].sCurrency,
        dApprove: res[0].dApprove,
        sApprove: res[0].sApprove,
        IsDelete: res[0].IsDelete
      });

      this._ArrData = [];
      this._ArrDataFilter.forEach(val => this._ArrData.push(Object.assign({}, val)));
      this.BindDataTable();
    }

    this.System.UnBlockUI();
  }
  //#endregion
}
